import Cookies from 'js-cookie';

const ATTRIBUTE_CODE = 'code';
const ATTRIBUTE_READY = 'ready';
const COOKIE_NAME = 'wixReferral';
const COOKIE_EXPIRATION_DAYS = 14;
const EVENT_READ_CODE = 'readCode';

// Cookie Manager is a custom element that we add in our Blocks widgets to get access
// to document.cookie (for reading and writing referral cookie).
export class CookieManager extends HTMLElement {
  static get observedAttributes() {
    return [ATTRIBUTE_CODE, ATTRIBUTE_READY];
  }

  attributeChangedCallback(attributeName: string, _oldValue: string, newValue: string) {
    // NOTE: There seems to be a bug in Velo platform where we cannot trigger `dispatchEvent()`
    // too soon. If we do this in constructor/connectedCallback - the associated 'readCode'
    // handler is not notified. As a workaround - we set a "ready" attribute when Velo is ready
    // to accept 'readCode' events.
    if (attributeName === ATTRIBUTE_READY) {
      this.dispatchReadCodeEvent();
    } else if (attributeName === ATTRIBUTE_CODE) {
      if (!newValue) {
        Cookies.remove(COOKIE_NAME);
      } else {
        const existingCode = Cookies.get(COOKIE_NAME);
        const code = existingCode ? existingCode : newValue; // Just extend time for existing cookie

        Cookies.set(COOKIE_NAME, code, {
          expires: COOKIE_EXPIRATION_DAYS,
          secure: true,
        });
      }
    }
  }

  dispatchReadCodeEvent() {
    const code = Cookies.get(COOKIE_NAME);
    const event = new CustomEvent(EVENT_READ_CODE, { detail: code });

    this.dispatchEvent(event);
  }
}
